"use client";

import { useEffect } from "react";
import { useTelegramContext } from "@/contexts/TelegramContext";
import { getTmaStartParams } from "@/utils/telegram";

const getSourceUtmsFromStorage = () => {
  const storedSources = localStorage.getItem("source-utms");
  if (storedSources) {
    return JSON.parse(storedSources) as string[];
  }
  return [];
};

const setSourceUtmsToStorage = (utms: string[]) => {
  localStorage.setItem("source-utms", JSON.stringify(utms));
};

/**
 * It tracks the origin of the user based on the utm parameter given by the partner
 * For web: gets UTM from URL parameters
 * For TMA: gets privateCampaign from Telegram startParam
 */
export const useUserSources = () => {
  const { isTMA } = useTelegramContext();

  const getSourceFromUrl = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const utm = searchParams.get("utm");
    return utm;
  };

  const getSourceFromTelegram = () => {
    if (!isTMA) {
      return null;
    }

    try {
      const decodedStartParams = getTmaStartParams();

      if (!decodedStartParams) {
        return null;
      }

      return decodedStartParams?.utm || null;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Failed to retrieve source from TMA launch params:", error);
      return null;
    }
  };

  const getCurrentSource = () => {
    return isTMA ? getSourceFromTelegram() : getSourceFromUrl();
  };

  const getSources = () => {
    // Get source from URL (web) or Telegram startParam (TMA)
    const source = getCurrentSource();

    const storedSources = getSourceUtmsFromStorage();

    if (source && !storedSources.includes(source)) {
      storedSources.push(source);
      setSourceUtmsToStorage(storedSources);
    }
    return storedSources;
  };

  useEffect(() => {
    getSources();
  }, []);

  return {
    getSources,
    getCurrentSource,
  };
};
